import React, {useEffect, useState} from 'react';

// Table component
const CFAdminVehicleBundleMatrix = ({ matrixDataValues, matrixSubColumnValues, matrixColumnValues, handleSelectedValues, matrixSelectedValues}: any) => {

    const [selectedIds, setSelectedIds] = useState<any[]>([]);

    useEffect(() => {
        setSelectedIds(matrixSelectedValues);
    }, [matrixSelectedValues]);

    const handleMatrixClick = async (event: any, rowId: any) => {

        handleSelectedValues(rowId, event.target.checked);
        if (event.target.checked) {
            setSelectedIds((prevSelectedIds) => [...prevSelectedIds, rowId]);
        } else {
            setSelectedIds((prevSelectedIds) => prevSelectedIds.filter((id) => id !== rowId));
        }

    };

    return (
        <div className="table-container1">
            <table>
                <thead>
                <tr>
                    <th rowSpan={2} className="table-header fixed-column fixed-column-1"> Vehicle </th>
                    <th rowSpan={2} className="table-header fixed-column fixed-column-2"> Year </th>
                    {matrixColumnValues?.map((header: any, index: number) => (
                        <th key={'col-' + header.id} colSpan={header.colSpan}
                            className="table-header cell expand-maximum-on-hover">{header.name}</th>
                    ))}
                </tr>
                <tr>
                    {matrixSubColumnValues?.map((header: any, index: number) => (
                        <th key={'subcol-'+header.id} colSpan={header.colSpan} className="table-header cell expand-maximum-on-hover">{header.name}</th>
                    ))}
                </tr>
                </thead>
                <tbody>
                {matrixDataValues?.map((row: any) => (
                    <tr key={row.id}>
                        <td key={'name-' + row.id} className="fixed-column fixed-column-1">{row.name}</td>
                        <td key={'year-' + row.id} className="fixed-column fixed-column-2">{row.year}</td>
                        {row.subData?.map((subData: any) => (
                            <td key={'subcol-' + subData.id} className="center-items">
                                <div className="small-checkbox">
                                    <input type="checkbox" id={`checkbox-${subData.id}`}
                                           data-testid={`checkbox-${subData.id}`}
                                           checked={selectedIds.includes(subData.id)}
                                           onChange={(event) => handleMatrixClick(event, subData.id)}/>
                                    <label htmlFor={`checkbox-${subData.id}`}
                                           data-testid={`label-${subData.id}`}>
                                        <span className="sr-only">{`Select ${subData.id}`}</span>
                                    </label>
                                </div>
                            </td>
                        ))}
                    </tr>
                ))}
                </tbody>
            </table>
        </div>
    );
};

export default CFAdminVehicleBundleMatrix;